import { onBeforeUnmount, ref, watch, type Ref } from 'vue'

const RECONNECTED_DISPLAY_MS = 1500

export type MaintenanceDisplayMode = 'app' | 'board' | 'reconnected'

// Drives the board -> "back online" -> app transition so flipping back to
// "off" never swaps the board out for real content instantly — the user
// always sees a brief confirmation first.
export function useMaintenanceReveal(isDisabled: Ref<boolean>) {
  const displayMode = ref<MaintenanceDisplayMode>(
    isDisabled.value ? 'board' : 'app'
  )
  let reconnectTimer: ReturnType<typeof setTimeout> | null = null

  const clearReconnectTimer = () => {
    if (reconnectTimer) {
      clearTimeout(reconnectTimer)
      reconnectTimer = null
    }
  }

  watch(isDisabled, (disabled) => {
    if (disabled) {
      clearReconnectTimer()
      displayMode.value = 'board'
      return
    }

    if (displayMode.value === 'board') {
      displayMode.value = 'reconnected'
      reconnectTimer = setTimeout(() => {
        displayMode.value = 'app'
        reconnectTimer = null
      }, RECONNECTED_DISPLAY_MS)
    }
  })

  onBeforeUnmount(clearReconnectTimer)

  return { displayMode }
}
